// Stock allauth 65.19.5 usersessions wire data. These numeric IDs identify
// management records, never Django session keys or browser credentials.
export interface ManagedSession {
  id: number;
  userAgent: string;
  ip: string | null;
  createdAt: number;
  lastSeenAt?: number;
  isCurrent: boolean;
}
export interface ManagedSessionSnapshot {
  actorId: string | number;
  revision: number;
  sessions: ManagedSession[];
}
export function parseManagedSessions(value: unknown): ManagedSession[] {
  const object = (item: unknown): item is Record<string, unknown> =>
    typeof item === "object" && item !== null && !Array.isArray(item);
  const timestamp = (item: unknown): item is number =>
    typeof item === "number" && Number.isFinite(item) && item >= 0 && item <= 8640000000000;
  if (!object(value) || value.status !== 200 || !Array.isArray(value.data)) {
    throw new Error("Session list could not be verified.");
  }
  const ids = new Set<number>();
  let current = 0;
  const sessions = value.data.map((item) => {
    if (
      !object(item) ||
      !Number.isSafeInteger(item.id) ||
      (item.id as number) <= 0 ||
      ids.has(item.id as number) ||
      typeof item.user_agent !== "string" ||
      (item.ip !== null && typeof item.ip !== "string") ||
      !timestamp(item.created_at) ||
      typeof item.is_current !== "boolean" ||
      (item.last_seen_at !== undefined && !timestamp(item.last_seen_at))
    ) {
      throw new Error("Session list could not be verified.");
    }
    ids.add(item.id as number);
    if (item.is_current && ++current > 1) throw new Error("Session list could not be verified.");
    return {
      id: item.id as number,
      userAgent: item.user_agent,
      ip: item.ip as string | null,
      createdAt: item.created_at,
      isCurrent: item.is_current,
      ...(item.last_seen_at !== undefined ? { lastSeenAt: item.last_seen_at as number } : {}),
    };
  });
  if (sessions.length && current !== 1) throw new Error("Session list could not be verified.");
  return sessions;
}
export function deviceTitle(agent: string): string {
  const browser = /Edg\//.test(agent)
    ? "Edge"
    : /Firefox\//.test(agent)
      ? "Firefox"
      : /Chrome\/|CriOS\//.test(agent)
        ? "Chrome"
        : /Safari\//.test(agent)
          ? "Safari"
          : "Unknown browser";
  const system = /iPhone|iPad/.test(agent)
    ? "iOS"
    : /Android/.test(agent)
      ? "Android"
      : /Windows/.test(agent)
        ? "Windows"
        : /Macintosh|Mac OS X/.test(agent)
          ? "macOS"
          : /Linux/.test(agent)
            ? "Linux"
            : null;
  return system ? `${browser} on ${system}` : browser;
}
